export enum InventoryStatus {
  Active = "ACTIVE",
  Broken = "BROKEN",
  Repair = "REPAIR",
  Inactive = "INACTIVE"
}
